export interface PM_Duration_Interface {
  id:number,
  title:String,
  duration: number,

  persianDate: string,
  username:string,
  del: boolean,

}

export function Empty_PM_Duration_Interface():PM_Duration_Interface{
  return{
    id:0,
    title:'',
    duration: 0,

    persianDate: '',
    username:'',
    del: false,
  }
}
